import type {
    AbstractControl,
    ValidationErrors,
    ValidatorFn,
} from '@angular/forms';
import { isValidPhone } from '../phone';
import type { CountryCode } from 'libphonenumber-js/min';

/**
 * Custom phone validator that uses libphonenumber-js for robust international phone number validation.
 *
 * @returns ValidatorFn that returns ValidationErrors object with phone: true on failure, null on success
 *
 * @example
 * ```typescript
 * // Usage in FormControl
 * phone: new FormControl('', [phoneValidator()])
 *
 * // Usage in FormBuilder
 * phone: ['', [phoneValidator()]]
 * ```
 */
export function phoneValidator(countryCode?: CountryCode): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        // Let required validator handle empty values
        if (!value) {
            return null;
        }

        // Use consolidated validation function
        const isValid = isValidPhone(value, countryCode ?? 'AU');

        return isValid ? null : { phone: true };
    };
}
